import { Controller } from "stimulus"
import { h, render, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'

class PopoverController extends Controller {
  connect() {
    render(<Popover popoverName={this.data.get('name')} />, this.element);
  }

  show() {
    EventManager.emit('show-popover', {
      name: this.data.get('name')
    })
  }

  hide() {
    EventManager.emit('hide-popover', {
      name: this.data.get('name')
    })
  }

  toggle() {
    EventManager.emit('toggle-popover', {
      name: this.data.get('name')
    })
  }
}

const Popover = ({popoverName}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    EventManager.on('show-popover', ({ name }) => {
      if (name === popoverName) {
        setShow(true)
      }
    })
    EventManager.on('hide-popover', ({ name }) => {
      if (name === popoverName) {
        setShow(false)
      }
    })
    EventManager.on('toggle-popover', ({ name }) => {
      if (name === popoverName) {
        setShow(prevShow => !prevShow)
      }
    })
  }, [])

  return (
    <Fragment>
    {
      show && popoverName == 'password' && (
        <div className="t-absolute t-flex t-flex-col t-right-0 t--top-36 t-p-4 t-border t-border-gray-60 t-shadow-xl t-bg-white t-z-10">
          <p className="t-text-gray-650 t-text-3xs t-font-semibold t-uppercase t-mb-0">
            Password Requirements
          </p>
          <p className="t-text-base t-mt-2">
            At least 8 characters
          </p>
          <p className="t-text-base t-mt-2">
            1 uppercase letter
          </p>
          <p className="t-text-base t-mt-2">
            1 special character
          </p>
          <p className="t-text-base t-mt-2">
            1 number
          </p>
        </div>
      )
    }
    {
      show && popoverName == 'cvc' && (
        <div className="t-absolute t-flex t-flex-col t-right-0 t--top-52 t-p-4 t-border t-border-gray-60 t-w-89 t-shadow-xl t-bg-white t-z-10">
          <p className="t-text-base">
            For Visa, Mastercard and Discover credit cards, find the three-digit security code on the back of the card, to the right of the signature panel. For American Express credit cards, find the four-digit security code on the front of the card, just above and to the right of the card number.
          </p>
        </div>
      )
    }
    </Fragment>
  )
}

export default PopoverController;
